import { createSharedStore } from "./store";

export function onRemoved(el: HTMLElement, callback: () => void) {
    if (!el.parentNode) return;

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            for (const node of mutation.removedNodes) {
                if (node === el) {
                    callback();
                    observer.disconnect();
                }
            }
        });
    });

    const config = { childList: true };
    observer.observe(el.parentNode, config);
}

export function onResized(el: HTMLElement, callback: () => void) {
    const rect = el.getBoundingClientRect();
    let prevWidth = 0;
    let prevHeight = 0;

    function onResized() {
        const rect = el.getBoundingClientRect();
        const hasChanged = rect.width !== prevWidth || rect.height != prevHeight;

        if (hasChanged) {
            prevWidth = rect.width;
            prevHeight = rect.height;
            callback();
        }
    }

    window.addEventListener('resize', onResized);
    onRemoved(el, () => {
        window.removeEventListener('resize', onResized);
    });

    onResized();
}

export function addStylesheet(url: string) {
    const resolvedUrl = import.meta.resolve(url);

    const existing = document.head.querySelector('link[href="' + resolvedUrl + '"]');
    if (existing) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = resolvedUrl;
    document.head.appendChild(link);
}

export function isElementInViewport (el: HTMLElement) {
    const rect = el.getBoundingClientRect();

    if (rect.width === 0 && rect.height === 0)
        return false;

    if (rect.bottom <= 0) return false;
    if (rect.right <= 0) return false;
    if (rect.top >= window.innerHeight) return false;
    if (rect.left >= window.innerWidth) return false;

    const windowRect: DOMRect = new DOMRect(0, 0, window.innerWidth, window.innerHeight);

    return rectIntersects(rect, windowRect);
}

const rectIntersects = (rectA: DOMRect, rectB: DOMRect) => {
    if (rectA.left > rectB.right || rectA.right < rectB.left) return false;
    if (rectA.bottom < rectB.top || rectA.top > rectB.bottom) return false;
    return true;
}
